<template>
  <div style="padding-bottom: 15px">
    <mu-card-header
      titleClass="largeTitle boldTitle"
      :title="title"
      :subTitle="subTitle"
    ></mu-card-header>
    <mu-flexbox v-if="isLoading" justify="center center" align="center center" style="height: 316px;">
      <mu-flexbox-item align="center">
        <mu-circular-progress :size="46"></mu-circular-progress>
        <br/>
        <span v-text="$t('message.loadingText')"></span>
      </mu-flexbox-item>
    </mu-flexbox>
    <mu-card-text v-if="!isLoading && subscription" class="form-group subscription-card">
      <div class="flex">
        <div :class=" subscription.isActive === 'active' ? 'detail spacing active-detail' : 'detail spacing inactive-detail'">
          {{subscription.isActive === 'active' ? 'Active' : 'Inactive' }}</div>
        <div v-if="!invoice && subscription.isActive === 'active'" class="detail active-detail spacing">
          Cancelling {{formatDate(parseInt(subscription.end_date))}} <mu-icon value="timer"/></div>
        <div v-if="!invoice && subscription.isActive !== 'active'" class="detail active-detail spacing">
          Cancelled </div>
      </div>
      <div class="flex">
        <div class="duration spacing">{{subscription.interval}}</div>
        <div>
          <span> - </span>
        </div>
        <div class="amount spacing"> {{subscription.currency+" "}}{{subscription.amount}}</div>
      </div>
      <div v-if="invoice" class="flex">
        <div class="info spacing">
          Next Invoice on {{formatDate(parseInt(subscription.end_date))}} {{subscription.currency+" "}}{{subscription.amount}}
        </div>
      </div>
      <div v-if="subscription.isActive === 'active'" class="flex flex-right">
        <mu-raised-button
        @click.native="manageSubscription()"
        :disabled="isSaving"
        :label="isSaving ? $t('message.sendingText') + '...' : (!invoice) ? $t('message.restoreText') : $t('message.cancelText')"

        secondary>
      </mu-raised-button>
      </div>
    </mu-card-text>
    <mu-card-text v-if="!isLoading && !subscription" class="form-group subscription-card">

      <div class="flex">
        <div class="info spacing">
          No Active Stripe Subscription at the moment
        </div>
      </div>

    </mu-card-text>
  </div>
</template>
<script>
  import PaymentApi from '../../api/Payment'

  export default {
    components: {
    },
    name: 'settings-subscription',
    data() {
      return {
        title: this.$t('message.subscriptionPreferencesTitle'),
        subTitle: this.$t('message.subscriptionPreferencesSubTitle'),
        isSaving: false,
        isLoading: false,
        subscription: null,
        invoice: null
      }
    },
    mounted() {
      let self = this;
      self.$gtag.pageview('/settings/subscription')
      self.fetchUserInvoice();
    },
    methods: {
      formatDate(date) {
        return new Date(date * 1000).toDateString();
      },
      fetchUserInvoice(){
        this.isLoading = true;
        PaymentApi.getUpcomingInvoice().then(res => {
          this.subscription = res.data.data.subscription
          this.invoice = res.data.data.invoice
          this.isLoading = false;
        }).catch((e) => {
           this.subscription = null
          this.invoice = null
          this.isLoading = false;
        })
      },
      manageSubscription() {
        if(this.invoice) this.cancelSubscription();
        else this.restoreSubscription();
      },
      cancelSubscription(){
        const self = this;
        self.$alert({
        title: "Are you sure?",
        text: "Your subscription will be terminated at the end of the current billing cycle, Are you sure you want to proceed?",
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white",
        preConfirm: function () {
          self.isSaving = true;
          return PaymentApi.cancelCurrentSubscription();
        }
      })
      .then(function (response) {
        self.isSaving = false;
        self.$toastr.success(response.data.message);
        self.fetchUserInvoice()
      }.bind(self))
      .catch(self.$alert.noop);
      },
      restoreSubscription(){
        const self = this;
        self.$alert({
        title: "Are you sure?",
        text: "Your subscription will be renewed at the end of the current billing cycle, Are you sure you want to proceed?",
        type: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: false,
        confirmButtonColor: "white",
        cancelButtonColor: "white",
        preConfirm: function () {
          self.isSaving = true;
          return PaymentApi.resumeCurrentSubscription();
        }
      })
      .then(function (response) {
        self.isSaving = false;
        self.$toastr.success(response.data.message);
        self.fetchUserInvoice()
      }.bind(self))
      .catch(self.$alert.noop);
      },

    }
  }
</script>
<style>

  .flex {
    display: flex;
  }
  .subscription-card{
    border: 1px solid #0379D4;
    border-radius: 30px;
    margin: 15px;
  }
  .spacing{
    margin: 5px 5px 5px 0px;
  }
  .detail {
    padding: 5px 15px;
    border-radius: 18px;
    color: black;
    font-weight: 600;
    display: flex;
    align-items: center;
  }
  .active-detail{
    background: #97f497;
  }
  .inactive-detail{
    background: #a09898;

  }
  .duration {
    font-weight: 700;
  }
  .amount {
    color: #0379D4;
    font-weight: 700;
  }
  .flex-right {
    justify-content: right;
  }
  .info {
    font-weight: 700;
    font-size: 16px;
    color: #908c8c;
  }
</style>



// WEBPACK FOOTER //
// Subscription.vue?64e4f74a